module.exports = __webpack_public_path__ + "img/full6-min.442b5a6e.png";